<template>
  <div class="grid-table-row">
    <div class="item__title font-condensed">
      {{ item.title }}
    </div>
    <div class="item__description">
      {{ item.description }}
    </div>
    <div class="item__date_opened d-flex d-md-block justify-content-between">
      <label class="d-block d-md-none mr-auto">{{ 'dateOpened' | translate(labels, 'TroubleshootingProcedures') }}</label>
      <div class="text-right text-md-left">
        <div class="item__date_value">{{ item.createdAt | formatDate }}</div>
        <div class="item__days_ago d-block d-md-none">
          ({{ daysSince(item.createdAt) }} {{ 'daysAgo' | translate(labels, 'TroubleshootingProcedures') }})
        </div>
      </div>
    </div>
    <div class="item__session_actions d-flex justify-content-end">
      <b-btn variant="outline-primary"
             size="sm"
             class="font-condensed text-nowrap"
             :data-test-id="'open-session-item__review__' + item.session_id"
             @click.stop.prevent="$emit('review', item.session_id)"
      >
        {{ 'review' | translate(labels, 'TroubleshootingProcedures') }}
      </b-btn>
      <b-btn v-if="item.isResumingAllowed"
             variant="primary"
             size="sm"
             class="font-condensed text-nowrap"
             :disabled="resuming"
             :data-test-id="'open-session-item__resume__' + item.session_id"
             @click.stop.prevent="$emit('resume', item.session_id)"
      >
        {{ 'resume' | translate(labels, 'TroubleshootingProcedures') }}
      </b-btn>
    </div>
  </div>
</template>

<script>
import {daysSince} from '@/helpers/dateTimeUtils'

export default {
  conceptName: ['TroubleshootingProcedures', 'HistoryWidget'],
  props: {
    item: {
      type: Object,
      required: true
    },
    resuming: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    daysSince
  }
}
</script>
